import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-miterlimit": "10",
      d: "M11.374 1.506c-2.79 0-4.926.68-6.32 1.819-.995.81-1.612 1.854-1.821 3.05-.148.845.543 1.614 1.443 1.614h14.7c.902 0 1.532-.863 1.205-1.664-.42-1.03-1.12-1.946-2.067-2.695-1.671-1.32-4.11-2.124-7.14-2.124ZM4.186 18.646c-.876 0-1.354 1.151-.782 1.841 1.037 1.25 3.512 2.106 8.436 2.106 5.67 0 8.094-1.135 8.81-2.7.25-.542-.137-1.247-.713-1.247zM19.183 13.786s-3.664-.074-7.24-.074c-3.578 0-7.243.074-7.243.074-.765 0-1.386.514-1.386 1.147 0 .634.62 1.147 1.386 1.147 0 0 3.58-.111 7.424-.111s7.06.111 7.06.111c.764 0 1.385-.514 1.385-1.147s-.62-1.147-1.386-1.147Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      d: "M14.26 10.398c-.809 0-1.39.827-2.31.827s-1.307-.842-2.27-.825c-.965.017-1.128.825-2.271.825S6.324 10.4 5.138 10.4c-.688 0-1.47.616-1.8.85"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-miterlimit": "10",
      d: "M20.51 11.237c-.325-.207-.942-.84-1.632-.84-.808 0-1.483.84-2.402.84-.92 0-1.253-.839-2.216-.839"
    }, null, -1)
  ])))
}
export default { render: render }